;(function () {

"use strict";

var SliderView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.group = opts.group || 1;

    this.$frame = this.$el.find('.frame');
    this.$slides = this.$el.find('ul').first();
    this.slides = this.$slides.children().toArray();

    this.idx = this.$slides.find('.active')[0] ? this.$slides.find('.active').index() : 0;
    this.max = this.slides.length/this.group;

    if (this.$slides.children().length/this.group > 1) {
      this.buildArrows();
      this.buildNav();
    }

    if (window.App.touch) {
      this.$el.on('swiperight', _.bind(this.prev, this));
      this.$el.on('swipeleft', _.bind(this.next, this));
    }
  },
  buildArrows: function () {
    this.$next = $("<div>").addClass('next');
    this.$prev = $("<div>").addClass('prev');
    this.$frame.append(this.$prev).append(this.$next);
    this.updateArrows();
  },
  buildNav: function () {
    // console.log('building nav');
    this.$nav = $("<ul class='nav'>");
    for (var i = 0; i < Math.ceil(this.slides.length/this.group); ++i) {
      var $el = $('<li>');
      this.$nav.append($el);
    }
    this.$frame.append(this.$nav);
    this.updateNav();
  },
  updateArrows: function () {
    // this.$next.removeClass('inactive');
    // this.$prev.removeClass('inactive');

    // if (this.idx > this.max-1) {
    //   this.$next.addClass('inactive');
    // }

    // if (this.idx <= 0) {
    //   this.$prev.addClass('inactive');
    // }
  },
  updateNav: function () {
    this.$nav.find('li.active').removeClass('active');
    $(this.$nav.find('li')[this.idx]).addClass('active');
  },
  render: function () {
    this.reset();
    var idx = this.idx*this.group;
    var els = this.slides.slice(idx, idx+this.group);

    _.each(els, function (el) {
      $(el).addClass('active').removeClass('prev');
    });

    this.updateNav();
    this.updateArrows();
  },
  reset: function () {
    this.$slides.find('.prev').removeClass('prev');
    this.$slides.find('li.active').addClass('prev').removeClass('active');
  },
  next: function (e) {
    if (e) { e.preventDefault(); }
    if ((this.idx+1) * this.group >= this.slides.length) {
      this.idx = -1; 
    }
    this.idx++;
    this.render();
  },
  prev: function (e) {
    if (e) { e.preventDefault(); }
    if (this.idx <= 0) {
      this.idx = Math.ceil(this.slides.length/this.group);
      // console.log(this.idx);
    }
    this.idx--;
    this.render();
  },
  navClick: function (e) {
    var idx = $(e.currentTarget).index();
    this.idx = idx;
    this.render();
  },
  events: {
    'click .next': 'next',
    'click .prev': 'prev',
    'click ul.nav > li': 'navClick'
  }
});

module.exports = SliderView;

}());